<template>
  <v-dialog
    v-model="notesDialog"
    persistent
    width="500"
  >
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip
        top
        color="primary"
      >
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
          >
            <v-icon>{{ dialogMode === 'New' ? 'mdi-plus-circle' : 'mdi-pencil-outline'}}</v-icon>
          </v-btn>
        </template>
        <span>{{ dialogMode }} Note</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="text-h5 accent lighten-2">
        {{ dialogMode }} Note
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              class="text-center"
            >
              <v-form
                ref="noteform"
                lazy-validation
              >
                <v-text-field
                  v-model="noteTitle"
                  :rules="[rules.required]"
                  outlined
                  label="Title"
                />
                <v-textarea
                  v-model="noteDetails"
                  :rules="[rules.required]"
                  outlined
                  label="Details"
                />
                <v-switch
                  v-model="noteImportance"
                  label="Important"
                  true-value="y"
                  false-value="n"
                />
                <v-switch
                  v-if="dialogMode === 'Edit'"
                  v-model="noteDeleted"
                  label="Deleted"
                  true-value="y"
                  false-value="n"
                />
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="notesDialog = false"
        >
          CANCEL
        </v-btn>
        <v-btn
          color="accent"
          @click="confirmNoteAction"
        >
          CONFIRM
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'NotesDialog',
    props: {
      contractId: Number,
      dialogMode: String,
      note: Object,
    },
    data () {
      return {
        noteTitle: '',
        noteDetails: '',
        noteImportance: 'n',
        noteDeleted: 'n',
        notesDialog: false,
        rules: {
          required: value => !!value || 'Required.',
        },
      }
    },
    computed: {
      noteData () {
        const fields = {
          contract_id: this.contractId,
          title: this.noteTitle,
          details: this.noteDetails,
          important: this.noteImportance
        }

        if (this.dialogMode === 'Edit') {
          fields.deleted = this.noteDeleted
        }

        return fields
      },
    },
    created () {
      if (this.note !== undefined) {
        this.noteTitle = this.note.title
        this.noteDetails = this.note.details
        this.noteImportance = this.note.important
        this.noteDeleted = this.note.deleted
      }
    },
    methods: {
      confirmNoteAction: function () {
        if (this.$refs.noteform.validate()) {
          this.notesDialog = false
          // console.log(this.noteData)
          if (this.dialogMode === 'New') {
            this.$emit('createNote', this.noteData)
          } else if (this.dialogMode === 'Edit') {
            this.$emit('editNote', this.noteData, this.note.id)
          } else {
            console.log('Something went wrong here')
          }
          
        }
      },
    },
  }
</script>
